const findMatchingCondition = (enumerationContent, quantity) => {
  const numericKeys = Object.keys(enumerationContent);
  for (const key of numericKeys) {
    const isEqual = !key.startsWith(">") && !key.startsWith("<") && !key.startsWith("=") && parseFloat(key) === quantity || key.startsWith("=") && parseFloat(key.slice(1)) === quantity;
    const isSuperior = key.startsWith(">") && quantity > parseFloat(key.slice(1));
    const isSuperiorOrEqual = key.startsWith(">=") && quantity >= parseFloat(key.slice(2));
    const isInferior = key.startsWith("<") && quantity < parseFloat(key.slice(1));
    const isInferiorOrEqual = key.startsWith("<=") && quantity <= parseFloat(key.slice(2));
    if (isEqual || isSuperior || isSuperiorOrEqual || isInferior || isInferiorOrEqual) {
      return key;
    }
  }
};
const getEnumeration = (enumerationContent, quantity) => {
  const key = findMatchingCondition(enumerationContent, quantity) ?? "fallback";
  return enumerationContent[key];
};
export {
  findMatchingCondition,
  getEnumeration
};
//# sourceMappingURL=getEnumeration.mjs.map